export enum UserRoleEnum {
    Administrator = 'Administrator',
    EventsManager = 'EventsManager',
    ReservationManager = 'ReservationManager',
    SalesChannel = 'SalesChannel'
}